<template lang="pug">
div
    RoleSelect(v-if="loaded")
    div(v-if="allowedRoles.includes(login_user.role)")
        h1 Import File
        b-card.border-0
            b-alert(variant="warning" show) This only work with Chromium-based browser!
            b-form(@submit.prevent="importAttachment")
                b-form-group(label="Choose a folder with subdirectories of RefId_Name inside:")
                    input(type="file" id="files" @change="processFile()" webkitdirectory required)
                b-form-group
                    b-button(type="submit" :disabled="isSubmitting || !uploadedFiles") {{ isSubmitting ? 'Importing...' : 'Import'}}
                
                b-spinner.mr-2(v-if="isSubmitting" small variant="secondary" label="Spinning")
                span(v-if="isSubmitting") Importing files...

                div(v-for="errMsg in errorLog")
                    div.text-danger
                        b-icon.mr-1(icon="exclamation-triangle")
                        | {{errMsg}}

                ol
                    li(v-for="status in statusMsg")
                        | {{status}}
    div(v-else)
        p.my-4 You're not allowed to view this page as {{login_user.role.replace(/_/g, ' ')}}
</template>

<script>
import RoleSelect from '@/components/roleSelect.vue';

export default {
    components: {
        RoleSelect,
    },
    computed: {
        loaded(){
            return this.$store.state.loaded;
        },
        login_user(){
            return this.$store.state.login_user;
        }
    },
    data(){
        return{
            allowedRoles:['admin'],
            isSubmitting: false,
            errorLog: [],
            statusMsg: [],
            uploadedFiles: null,
        }
    },
    methods: {
        processFile() {
            this.uploadedFiles = document.getElementById("files").files;
        },
        async importAttachment() {
            this.isSubmitting = true;
            this.errorLog = [];

            let index = 0

            let promises = [];
            for(let file of this.uploadedFiles) {
                
                promises.push(this.uploadAttachment(file, index));

                index++;
            }

            await Promise.all(promises);
            
            this.isSubmitting = false;
        },
        async uploadAttachment(file, index) {
            let refId = (file.webkitRelativePath.split('/')[1]).split('_')[0];
            //console.log(refId);

            // check if case exist
            this.statusMsg[index] = `FINDING ${refId}...`;
            let caseObj = await this.getCaseByRefId(refId);
            if(!caseObj) {
                this.statusMsg[index] = `FAIL to find ${refId}.`;
                return;
            }

            // if there is subfolder in refid folder, use the folder name as tag/header in filename
            let tag = null;
            if(file.webkitRelativePath.split('/').length > 3) {
                // get folder name
                tag = file.webkitRelativePath.split('/').slice(-2, -1)[0];
            }

            this.statusMsg[index] = `UPLOADING ${file.webkitRelativePath}.`;

            return await this.$store.dispatch('addCaseAttachment', {caseId:caseObj.new_caseid, payload:file, tag:tag}).then(()=>{
                this.statusMsg[index] = `SUCCESS to upload ${file.webkitRelativePath}.`;
            }).catch(()=>{
                this.statusMsg[index] = `FAIL to upload ${file.webkitRelativePath}.`;
            });
        },
        async getCaseByRefId(refId) {
            if(!refId) {return false;}

            return await this.$store.dispatch('getCaseByRefId', refId).then((result)=>{
                if(result.value.length > 0)
                    return result.value[0];
                else
                    return false;
            }).catch(()=>{
                return false;
            })
        },
    }
}
</script>

<style>

</style>